import { Injectable } from '@angular/core';

const TOKEN_KEY = 'Afrisure-Token';
const REFRESH_TOKEN = 'Refresh-Token';
const CUSTOMER_TOKEN='Customer-Token'

@Injectable(
  {
    providedIn:'root'
  }
)
export class TokenStorage {
  save(token: any) {
    window.localStorage[TOKEN_KEY] = token;
  }

  get() {
    return window.localStorage[TOKEN_KEY] && window.localStorage[TOKEN_KEY].trim() !== '' ? window.localStorage[TOKEN_KEY] : null;   
  }

  destroy() {
    window.localStorage.removeItem(TOKEN_KEY);
  }
  saveRT(token: any) {
    window.localStorage[REFRESH_TOKEN] = token;
  }
  getRT() {
    if (window.localStorage[REFRESH_TOKEN]) {
      return window.localStorage[REFRESH_TOKEN];
    } else {
      return ''
    }
  }
  destroyRT() {
    window.localStorage.removeItem(CUSTOMER_TOKEN);
  }

}
